/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { Button, Input, PageHeader, Spinner } from '@/components/ui';
import { api, qs } from '@/lib/api';
import { fmtDateTime } from '@/lib/format';
import { useDirectory } from '@/lib/hooks';

const ACT: Record<string, string> = { create: 'создание', update: 'изменение', delete: 'удаление', login: 'вход', 'login.failed': 'неудачный вход', merge: 'слияние', download: 'скачивание', upload: 'загрузка', import: 'импорт', stage: 'смена стадии' };

export function AuditPage() {
  const [entity, setEntity] = useState('');
  const [page, setPage] = useState(1);
  const { data: people } = useDirectory();
  const { data } = useQuery({ queryKey: ['audit', entity, page], queryFn: () => api.get(`/audit${qs({ entity, page, pageSize: 100 })}`) });
  const who = (id?: string) => people?.find((p) => p.id === id)?.fullName ?? (id ? id.slice(0, 8) : 'система');
  return (
    <>
      <PageHeader title="Журнал аудита" actions={<Input className="w-56" placeholder="Сущность: party, contract..." value={entity} onChange={(e) => { setEntity(e.target.value); setPage(1); }} />} />
      {!data ? <Spinner /> : (
        <div className="card overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50"><tr><th className="th">Когда</th><th className="th">Кто</th><th className="th">Действие</th><th className="th">Объект</th><th className="th">Изменения</th></tr></thead>
            <tbody>{data.map((a: any) => (
              <tr key={a.id} className="border-t border-slate-100">
                <td className="td whitespace-nowrap text-xs">{fmtDateTime(a.at)}</td><td className="td">{who(a.userId)}</td>
                <td className="td">{ACT[a.action] ?? a.action}</td><td className="td text-xs">{a.entity} {a.entityId?.slice(0, 8)}</td>
                <td className="td max-w-md"><code className="block max-h-24 overflow-auto whitespace-pre-wrap text-[11px] text-slate-600">{a.changes ? JSON.stringify(a.changes) : ''}</code></td>
              </tr>
            ))}</tbody>
          </table>
          <div className="flex justify-end gap-2 p-2">
            <Button size="sm" variant="secondary" disabled={page === 1} onClick={() => setPage(page - 1)}>Назад</Button>
            <Button size="sm" variant="secondary" disabled={data.length < 100} onClick={() => setPage(page + 1)}>Далее</Button>
          </div>
        </div>
      )}
    </>
  );
}
